import React from 'react';

export default function Topbar({ user, onTabSelect }) {
  return (
    <header className="sticky top-0 z-20 h-14 border-b border-gray-200 bg-white/80 backdrop-blur supports-[backdrop-filter]:bg-white/60">
      <div className="h-full max-w-7xl mx-auto px-3 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <button className="md:hidden inline-flex items-center justify-center h-9 w-9 rounded-md hover:bg-gray-100" aria-label="Open menu">
            {/* Implement mobile sidebar trigger as needed */}
            <span className="i-lucide-menu" aria-hidden="true">≡</span>
          </button>
          <a href="#overview" onClick={(e) => { e.preventDefault(); onTabSelect('overview'); }} className="font-semibold">Dashboard</a>
        </div>
        <div className="flex items-center gap-2">
          <button className="hidden sm:inline-flex items-center h-9 px-3 rounded-md border text-sm hover:bg-gray-50" aria-label="Search">/ Search</button>
          <button className="inline-flex items-center justify-center h-9 w-9 rounded-md hover:bg-gray-100" aria-label="Notifications">🔔</button>
          <div className="inline-flex items-center gap-2 pl-3 ml-3 border-l">
            <div className="h-8 w-8 rounded-full bg-gray-200 grid place-items-center">{user?.name?.[0] ?? 'U'}</div>
            <div className="hidden sm:flex flex-col leading-tight">
              <span className="text-sm font-medium">{user?.name || user?.email}</span>
              <span className="text-xs text-gray-500">{user?.role || 'user'}</span>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
